import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import api3000 from '../../services/api3000';

const UserStatusToggleModal = ({ user, onClose, onUpdated }) => {
    const token = localStorage.getItem('token');
    const newStatus = user.status === 'inativo' ? 'ativo' : 'inativo';

    useEffect(() => {
        Swal.fire({
            title: `Tem certeza que deseja ${newStatus === 'ativo' ? 'ativar' : 'inativar'} o usuário?`,
            text: `${user.nome} - ${user.email}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            customClass: {
                popup: 'swal2-custom-popup',
                title: 'swal2-custom-title',
                confirmButton: 'swal2-custom-confirm',
                cancelButton: 'swal2-custom-cancel',
            },
        }).then((result) => {
            if (result.isConfirmed) {
                api3000.put(`/api/users/${user.id}/update`, { status: newStatus }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                })
                    .then(({ data }) => {
                        Swal.fire('Sucesso!', data.message, 'success');
                        onUpdated();
                        onClose();
                    })
                    .catch((err) => {
                        Swal.fire('Erro!', err.response?.data?.message || err.message, 'error');
                    });
            } else {
                onClose(); 
            }
        });

    }, []);

    return null;
};

export default UserStatusToggleModal;
